import videojs from "video.js";
import global from "./global";

if (!global.videojs) {
    global.videojs = videojs;
}

export default global.videojs;
